import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTotalBalance } from "./totalBalanceApi";

const initialState = {
  balance: 0,
  loading: false,
  isError: false,
  error: "",
};

export const fetchTotalBalance = createAsyncThunk(
  "balance/fetchTotalBalance",
  async () => {
    const balance = await getTotalBalance();
    return balance;
  }
);

const totalBalanceSlice = createSlice({
  name: "balance",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchTotalBalance.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchTotalBalance.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.balance = action.payload;
      })
      .addCase(fetchTotalBalance.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.balance = 0;
      });
  },
});

export default totalBalanceSlice.reducer;
